import { render, staticRenderFns } from "./DspPartnersDetails.vue?vue&type=template&id=5812681d&scoped=true&"
import script from "./DspPartnersDetails.vue?vue&type=script&lang=js&"
export * from "./DspPartnersDetails.vue?vue&type=script&lang=js&"
import style0 from "./DspPartnersDetails.vue?vue&type=style&index=0&id=5812681d&prod&lang=scss&scoped=true&"
import style1 from "./DspPartnersDetails.vue?vue&type=style&index=1&id=5812681d&prod&lang=scss&"
import style2 from "./DspPartnersDetails.vue?vue&type=style&index=2&id=5812681d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5812681d",
  null
  
)

export default component.exports